<template>
    <div class="m-listingitem">
        <div class="e-image">
            <ul class="e-data">
                <li v-if="resultItem.Content && resultItem.Content.PropertyPhotos">{{resultItem.Content.PropertyPhotos.length}}</li>
                <li v-if="resultItem.Content && resultItem.Content.PropertyHasDocuments">
                    <i class="fa fa-arrow-down" aria-hidden="true"></i>
                </li>
                <li v-if="resultItem.Content && resultItem.Content.PropertyHasVideo">
                    <i class="fa fa-play" aria-hidden="true"></i>
                </li>
            </ul>
            <a :href="returnUrl(resultItem.Link)">
                <thumbnail-image :photo-id="resultItem.Content.PropertyPhotos[0].MediaItem.Id"
                                 v-if="resultItem.Content && resultItem.Content.PropertyPhotos && resultItem.Content.PropertyPhotos[0].MediaItem"></thumbnail-image>
            </a>
        </div>
        <div class="e-text">
            <div class="top">
                <p class="contentcategory">Property</p>

                <h3>
                    <a :href="returnUrl(resultItem.Link)">{{resultItem.Heading}}</a>
                </h3>

                <p :title="truncate(resultItem.Content.PropertyDescription)" v-html="truncate(resultItem.Content.PropertyDescription)"></p>
            </div>

            <div class="buttons myhie">
                <a :href="returnUrl(resultItem.Link)" class="btn btn-green">Find out more</a>
                <profile-actions :page-id="resultItem.Id.toString()"></profile-actions>
            </div>
        </div>
        <div class="e-map">
            <thumbnail-image :photo-id="resultItem.Content.PropertyPhotos[1].MediaItem.Id"
                             v-if="resultItem.Content && resultItem.Content.PropertyPhotos && resultItem.Content.PropertyPhotos.length > 1 && resultItem.Content.PropertyPhotos[1].MediaItem"></thumbnail-image>
        </div>
        <div class="e-amount">{{formatAskingPrice(resultItem.Content)}}</div>
    </div>
</template>

<script>
    import ProfileActions from '@/components/Utils/profile-actions'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'

    import { globalMixin } from '@/mixins/globalMixin.js'
    import { propertyMixin } from '@/mixins/propertyMixin.js'
    import { truncate } from '@/utils/strings.js'

    export default {
        components: {
            ProfileActions,
            ThumbnailImage
        },

        computed: {
            isLoggedIn: function () {
                return isLoggedIn
            }
        },

        methods: {
            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        mixins: [globalMixin, propertyMixin],

        props: {
            resultItem: {
                required: true,
                type: Object
            },
            hideImage: {
                required: false,
                type: Boolean
            }
        }
    }
</script>